module.exports = __webpack_public_path__ + "static/media/Gallary3.d795eda3.webp";